var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29303 16.707C9.10556 16.5195 9.00024 16.2651 9.00024 16C9.00024 15.7348 9.10556 15.4805 9.29303 15.293L12.586 12L9.29303 8.70698C9.11087 8.51838 9.01008 8.26578 9.01236 8.00358C9.01463 7.74138 9.1198 7.49057 9.30521 7.30516C9.49062 7.11975 9.74143 7.01458 10.0036 7.01231C10.2658 7.01003 10.5184 7.11082 10.707 7.29298L14.707 11.293C14.8945 11.4805 14.9998 11.7348 14.9998 12C14.9998 12.2651 14.8945 12.5195 14.707 12.707L10.707 16.707C10.5195 16.8945 10.2652 16.9998 10 16.9998C9.73487 16.9998 9.48056 16.8945 9.29303 16.707Z",
    fill: "#2A3842"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.47f1523c11e3e7651496a851aae78cdc.svg";
export { ForwardRef as ReactComponent };